import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Lock, Key, LogOut } from 'lucide-react';

const POSLockScreen = ({ 
  onUnlock, 
  unlocking, 
  isPopup, 
  onLogout 
}) => {
  const [unlockCredential, setUnlockCredential] = useState('');
  const [unlockMethod, setUnlockMethod] = useState('pin');

  const handleUnlockClick = () => {
    onUnlock(unlockMethod, unlockCredential, () => setUnlockCredential(''));
  };

  return (
    <div className="lock-screen" data-testid="pos-lock-screen">
      <div className="text-center max-w-sm mx-auto p-8">
        <div className="h-24 w-24 rounded-2xl bg-white/20 flex items-center justify-center mx-auto mb-6 backdrop-blur">
          <Lock className="h-12 w-12 text-white" />
        </div>
        <h1 className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Manrope' }}>POS Locked</h1>
        <p className="text-white/70 mb-8">Enter your PIN or password to unlock</p>
        
        <div className="flex justify-center gap-2 mb-6">
          <button
            onClick={() => setUnlockMethod('pin')}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${unlockMethod === 'pin' ? 'bg-white text-orange-600' : 'bg-white/20 text-white'}`}
          >
            <Key className="h-4 w-4 inline mr-1" /> PIN
          </button>
          <button
            onClick={() => setUnlockMethod('password')}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${unlockMethod === 'password' ? 'bg-white text-orange-600' : 'bg-white/20 text-white'}`}
          >
            <Lock className="h-4 w-4 inline mr-1" /> Password
          </button>
        </div>

        <Input
          type={unlockMethod === 'pin' ? 'text' : 'password'}
          placeholder={unlockMethod === 'pin' ? 'Enter PIN' : 'Enter Password'}
          value={unlockCredential}
          onChange={(e) => setUnlockCredential(unlockMethod === 'pin' ? e.target.value.replace(/\D/g, '') : e.target.value)}
          maxLength={unlockMethod === 'pin' ? 6 : 100}
          className="pin-input w-full mb-4 text-center"
          onKeyDown={(e) => e.key === 'Enter' && handleUnlockClick()}
          data-testid="unlock-input"
        />

        <Button
          onClick={handleUnlockClick}
          disabled={unlocking}
          className="w-full bg-white text-orange-600 hover:bg-white/90 font-semibold h-12"
          data-testid="unlock-btn"
        >
          {unlocking ? 'Unlocking...' : 'Unlock POS'}
        </Button>

        {isPopup && onLogout && (
          <Button
            onClick={onLogout}
            variant="ghost"
            className="w-full mt-4 text-white/70 hover:text-white hover:bg-white/10"
          >
            <LogOut className="h-4 w-4 mr-2" /> Logout
          </Button>
        )}
      </div>
    </div>
  );
};

export default POSLockScreen;
